import { render } from "./manageFaq.vue?vue&type=template&id=88d77154"
import script from "./manageFaq.vue?vue&type=script&lang=js"
export * from "./manageFaq.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Stage-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__